module.exports = __webpack_public_path__ + "static/media/picture11.956f0f2b.jpg";